// Access-period date helpers. Values are stored in UTC (ISO) on the backend and
// shown / entered in Indonesian Western Time (WIB, UTC+7, no DST).
const WIB_OFFSET_MS = 7 * 3600 * 1000;

const fmt = new Intl.DateTimeFormat("id-ID", {
  timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric",
  hour: "2-digit", minute: "2-digit", hour12: false,
});
const fmtDate = new Intl.DateTimeFormat("id-ID", {
  timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric",
});

const valid = (d) => d instanceof Date && !Number.isNaN(d.getTime());

/** "09 Okt 2026 11.03 WIB" (or "—" when empty). */
export function formatWib(iso, { dateOnly = false } = {}) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (!valid(d)) return "—";
  return dateOnly ? fmtDate.format(d) : `${fmt.format(d)} WIB`;
}

/** ISO (UTC) -> value for <input type="datetime-local"> expressed in WIB. */
export function toWibInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (!valid(d)) return "";
  return new Date(d.getTime() + WIB_OFFSET_MS).toISOString().slice(0, 16);
}

/** datetime-local value (interpreted as WIB) -> ISO UTC string, or null. */
export function fromWibInput(value) {
  if (!value) return null;
  const d = new Date(`${value}:00+07:00`);
  return valid(d) ? d.toISOString() : undefined; // undefined = invalid input
}

export function nowWibInput() {
  return toWibInput(new Date().toISOString());
}

/** Add calendar months to an ISO date (day clamped, e.g. 29 Feb -> 28 Feb). Mirrors the backend. */
export function addMonthsIso(iso, months) {
  const d = new Date(iso);
  const y = d.getUTCFullYear();
  const m = d.getUTCMonth() + months;
  const ty = y + Math.floor(m / 12);
  const tm = ((m % 12) + 12) % 12;
  const lastDay = new Date(Date.UTC(ty, tm + 1, 0)).getUTCDate();
  const out = new Date(d);
  out.setUTCFullYear(ty, tm, Math.min(d.getUTCDate(), lastDay));
  return out.toISOString();
}
